var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 3.45a1 1 0 011.2 0l7 5.25a1 1 0 01.4.8v11a.5.5 0 01-.5.5H14a.5.5 0 01-.5-.5v-5.4a.1.1 0 00-.062-.092L13.4 15h-2.8a.1.1 0 00-.1.1v5.4a.5.5 0 01-.5.5H4.5l-.1-.01a.5.5 0 01-.4-.49v-11a1 1 0 01.4-.8l7-5.25zm-5.9 6.3v9.75H9v-4.4a1.6 1.6 0 011.6-1.6h2.8a1.6 1.6 0 011.6 1.6v4.4h3.5V9.75L12 4.875 5.5 9.75z",
    fill: "currentColor"
  })));
}
SvgHome.displayName = 'Home';
export default SvgHome;